import Vue from 'vue'
import Vuex from 'vuex'
import { Constant } from '@/utils/const';
import axios from 'axios';
import router from '@/router';
import * as R from "ramda";

Vue.use(Vuex)

var timeOutID = null;
var socket = null;
const MAX_TRY_COUNT = 5;
var try_connect = 0;
// var connes = [];
var unsubscribe = null;


const SOCKSER_SERVER = process.env.VUE_APP_WEBSOCKET_SERVER;
// const SOCKSER_SERVER = process.env.NODE_ENV === 'production' ? "ws://next.weliveon.net:6001/ws" : "ws://localhost:9090/ws";

//todo: implements some code for refresh (attach socket automaticlly )



function getUUID() { // UUID v4 generator in JavaScript (RFC4122 compliant)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 3 | 8);
    return v.toString(16);
  });
}






const socketOpenListener = (event) => {




  let clsid = localStorage.getItem("clsid");
  let default_info = localStorage.getItem("default_info");



  function p2(store) {
    socket.onmessage = payload => {

      store.commit('WsReceiveData', payload.data);
      store.dispatch('WsEntry', payload.data);
    };



    unsubscribe = store.subscribe(mutation => {

      if (mutation.type === 'UPDATE_WSDATA') {
        let jsonString = JSON.stringify(mutation.payload);

        socket.send(jsonString);
      }

    });

  }
  p2(MyStore);


  let uuid = null;
  if (sessionStorage.getItem("uuid") != null) {
    uuid = sessionStorage.getItem("uuid")
  } else {
    uuid = getUUID();
    sessionStorage.setItem("uuid", uuid);
  }


  console.log(router.currentRoute.fullPath);
  if (clsid != null && default_info != null) {
    let socket_payload = {
      "wayto": "REGISTER_NICK_RE",
      "payload": {
        "classroom_id": clsid,
        "nick": default_info,
        "uuid": uuid
      }
    }

    socket.send(JSON.stringify(socket_payload));

  }

};


var isfirst = true;
var _keyID = null;
const socketCloseListener = (event) => {


  if (unsubscribe != null) {
    unsubscribe();
  }


  if (socket) {
    console.error('Disconnected.');
  }

  if (!isfirst) {
    if (MAX_TRY_COUNT > try_connect) {


      _keyID == setTimeout(() => {
        socket = new WebSocket(SOCKSER_SERVER);
        socket.addEventListener('open', socketOpenListener);
        socket.addEventListener('close', socketCloseListener);
        try_connect++;
      }, 2000)
    }

  } else {
    socket = new WebSocket(SOCKSER_SERVER);
    socket.addEventListener('open', socketOpenListener);
    socket.addEventListener('close', socketCloseListener);
  }

};
// alert("여기는 몇번");
socketCloseListener();
isfirst = false;


function bindItem(src, tar) {
  // console.log(src.payload);
  tar.itemMeta.item_id = src.payload.item_id;
  tar.itemMeta.title = src.payload.title;
  tar.itemMeta.index = src.payload.index;
  tar.itemMeta.answer = src.payload.answer;
  tar.itemMeta.flag = src.payload.flag;

  tar.itemMeta.answer_flag = src.payload.answer_flag;
  // state.itemMeta.jimun_multi = data.payload.jimun_multi;
  tar.itemMeta.paper_id = src.payload.paper_id;
}

// function bindItem(src, tar) {
//   // console.log(src.payload);
//   tar.itemMeta.item_id = src.payload.item_id;
//   tar.itemMeta.title = src.payload.title;
//   tar.itemMeta.index = src.payload.index;
//   tar.itemMeta.answer = src.payload.answer;
//   // state.itemMeta.jimun_multi = data.payload.jimun_multi;
//   tar.itemMeta.paper_id = src.payload.paper_id;
// }


var origState = {
  clsid: null,
  clsMeta: {},
  bannersrc: null,
  att_info: {},
  paper_qna: [], //  해당 클래스의  qna paper list
  paper_quiz: [],
  non_items: [],  // 비 실시간성 아이템 목록 
  non_answers: [],
  qnaMeta: {},  // 현재 qna 메타 정보
  item_starttime: 0,
  item_timeout: false,
  itemMeta: {
    item_id: null,
    title: null,
    timer: 0,
    mail_attachment: null,
    index: 1,
    answer: [],
    jimun_multi: [],
    paper_id: null,
    answer_flag: null,
    required: false,
    score: false,
    __page__: "NUMBER",
    details: [],
    bogi_deco: "text",
    my_answers: new Set([]),
    is_correct: false,
    my_rank: 0,
    my_point: 0,
    avg_point: 0,
    st1_point: 0,
    item_type: "quiz", // quiz || poll 

  },
  qna_list: [],  // 현재 qna list
  qna_order: 'recently',  // qna list  정렬조건
  qna_pos: 1,  //  qna list 현재 페이지
  qna_totalpage: 0,
  qna_view: {
    Qnalikes: [],
    Qnacomments: [],
    id: null,
    writer: null,
    secret: 0,
    text: "",
    paper_id: null,
    like_toggle: false,
  },
  qna_bg: "",
  qna_logical_index: "01",
  qna_more_count: 1,
  paper_slides: [],
  showGnb: false,
  mail1: "",
  mail2: "",
  slide: {
    index: 0,
    automode: false
  },
  hasTimeTable: false,
  sockettime: 0,

}

const MyStore = new Vuex.Store({
  state: origState,
  mutations: {
    WsReceiveData(state, data) {

      data = JSON.parse(data);

      if (data === 'ok') { return };
      let wayTo = data.wayto;
      let subflag = null;
      let details = null;
      let flag = null;

      if (wayTo.indexOf("ITEM") >= 0) {

        flag = data.payload.flag;
        subflag = data.payload.subflag;
        details = data.payload.details;
        state.itemMeta.item_type = flag;
      }

      // console.log(subflag);

      switch (wayTo) {
        case "ACTION_GOTO_HOME":
          window.document.location.href = "http://next.weliveon.net";
          break;

        case "ACTION_ITEM_DISPLAY":
          state.item_timeout = false;
          bindItem(data, state);
          state.itemMeta.__page__ = "NUMBER";
          router.replace("/quiz/main").catch(() => { });
          break;

        case "ACTION_ITEM_ALREADY_SENT":
          //todo: entry route for notifing situations
          state.item_timeout = false;
          bindItem(data, state);
          state.itemMeta.__page__ = "NUMBER";
          router.replace("/quiz/main").catch(() => { });

          break;
        case "ACTION_ITEM_START":

          state.itemMeta.my_answers = new Set([]);
          state.item_timeout = false;
          bindItem(data, state);

          // state.itemMeta.__page__ = "NUMBER";
          // if (flag === 'quiz') {
          //   router.push("/quiz/main").catch(() => { });
          // } else if (flag === 'poll') {
          //   router.push("/poll/main").catch(() => { });
          // }


          state.itemMeta.__page__ = "PLAY";

          state.item_starttime = new Date()

          // state.itemMeta = data.payload;

          if (flag === 'quiz') {
            state.itemMeta.my_answers = new Set([]);
            bindItem(data, state);
            state.itemMeta.bogi_deco = "text";
            details.forEach((item) => {
              if (item.bogitype === 'image') {
                state.itemMeta.bogi_deco = "image";
              }
            })
            router.replace("/quiz/main").catch(() => { });
          } else if (flag === 'poll') {
            state.itemMeta.my_answers = new Set([]);
            bindItem(data, state);
            state.itemMeta.bogi_deco = "text";
            details.forEach((item) => {
              if (item.bogitype === 'image') {
                state.itemMeta.bogi_deco = "image";
              }
            })

            router.replace("/poll/main").catch(() => { });
          }

          // details.forEach((item, index) => {
          //   item.kid = "example1_" + (index + 1);
          //   item.checked = false;
          // });
          let idx = 0;
          details = R.map(x => {
            x.kid = "example1_" + (idx + 1);
            x.checked = false;
            idx++;
            return x;

          }, details);
          console.log(details);

          state.itemMeta.details = details;


          break;
        case "ACTION_ITEM_CONFIRM":  // 개개인별의 데이터가 들어옴.
          state.itemMeta.__page__ = "CONFIRM";
          console.log(data.payload);
          bindItem(data, state);
          state.itemMeta.details = data.payload.details;
          let myarrs = data.payload.user_answers.split("$");
          state.itemMeta.my_answers = myarrs;

          state.itemMeta.is_correct = data.payload.is_correct;
          router.replace("/quiz/main").catch(() => { });
          break;


        case "ACTION_ITEM_FORCE": // 타임아웃으로 강제로 종료
          //todo: check  current route name  
          let pagenm = router.currentRoute.name;
          //todo: check status of user's reaction 
          // 1: already sent 
          // 2:  waiting  
          // 3: send answer in same session  

          if (pagenm === 'Item_Main') {
            state.item_timeout = true;
          }



          break;

        case "ACTION_ITEM_STAT":  // 개개인별의 데이터가 들어옴.
          if (flag === 'quiz') {
            state.itemMeta.__page__ = "STAT";
          }
          if (flag === 'poll') {
            state.itemMeta.__page__ = "POLLSTAT";
          }
          bindItem(data, state);
          router.replace("/quiz/main").catch(() => { });
          break;

        case "ACTION_ITEM_STATPOLL":  // 개개인별의 데이터가 들어옴.
          if (flag === 'quiz') {
            state.itemMeta.__page__ = "STAT";
          }
          if (flag === 'poll') {
            state.itemMeta.__page__ = "POLLSTAT";
          }
          bindItem(data, state);
          state.itemMeta.details = data.payload.details;
          state.itemMeta.stats = data.payload.stats;
          router.replace("/quiz/main").catch(() => { });
          break;



        case "ACTION_ITEM_RANK": // 개개인별의 데이터가 들어옴. 
          state.itemMeta.__page__ = "RANK";

          state.itemMeta.my_rank = data.payload.my_rank;
          state.itemMeta.my_point = data.payload.my_point;
          state.itemMeta.avg_point = data.payload.avg_point;
          state.itemMeta.st1_point = data.payload.st1_point;

          router.replace("/quiz/main").catch(() => { });
          break;

        case "ACTION_ITEM_FINALRANK":// 개개인별의 데이터가 들어옴. 
          state.itemMeta.__page__ = "FINALRANK";

          state.itemMeta.my_rank = data.payload.my_rank;
          state.itemMeta.my_point = data.payload.my_point;
          state.itemMeta.avg_point = data.payload.avg_point;
          state.itemMeta.st1_point = data.payload.st1_point;

          router.replace("/quiz/main").catch(() => { });
          break;


        case "ACTION_ITEM_FONT":
          break;

        case 'ACTION_ITEM_DENY':
          // alert('이미 출제 완료된 문제입니다.');
          break;

        case 'ACTION_RESET':
          localStorage.removeItem("default_info");
          let clsid = localStorage.getItem("clsid");
          localStorage.removeItem("default_info_" + clsid);
          // router.replace("/login/" + clsid).catch(() => { });


          location.reload();
          break;

        default:
        // console.log("default");
      }

    },
    setClsid(state, clsid) {
      state.clsid = clsid;
    },
    UPDATE_WSDATA(state, payload) {

    },
    YOU_DIED(state, payload) {

    },

    updateQnaView(state, payload) {
      state.qna_view = payload;
    },
    updateQnaViewText(state, payload) {
      // console.log(payload);
      state.qna_view.text = payload;
    },

    //handleSlide 슬라이드 이동
    handleSlide(state, payload) {
      state.slide.index = payload.pindex;
    },
    updateTime(state, payload) {
      state.sockettime = payload.time;
    }

  },
  actions: {
    WsEntry(context, data) {
      let jsonData = JSON.parse(data);

      switch (jsonData.wayto) {
        case "TEST_SOCKET_TIME":
          context.commit("updateTime", jsonData.payload)
          break;
        case "ACTION_NORMAL_DIED":
          context.commit('YOU_DIED', '')
          break;
        case "ACTION_SLIDE_GO":
          context.commit("handleSlide", jsonData.payload)
          break;

      }


    },
    initslide(context) {

      context.state.slide.index = 0;
      context.state.slide.automode = false;

    },

    nonReset(context) {
      context.state.non_answers = [];
    },
    qnaReset(context) {
      context.state.qna_more_count = 1;
    },
    pushWSMessage(context, payload) {
      context.commit(
        'UPDATE_WSDATA', payload
      )
    },
    pushYOUDIED(context) {
      context.commit(
        'YOU_DIED', ''
      )
    },


    toggleGnb(context) {
      context.state.showGnb = !context.state.showGnb;
    },
    offGnb(context) {
      context.state.showGnb = false;
    },


    loadQnaFullList(context) {
      let clsid = localStorage.getItem("clsid");
      let url = `${Constant.FullGetApi}?classroom_id=${clsid}&flag=qna`;
      axios.get(url).then(resp => {
        let rows = resp.data.rows;
        context.state.paper_qna = rows;
      });
    },
    loadSlideFullList(context) {
      let clsid = localStorage.getItem("clsid");
      let url = `${Constant.SlideGetApi}/${clsid}?flag=share`;
      axios.get(url).then(resp => {
        let rows = resp.data;

        rows = R.filter((i) => {
          if (i.Items.length > 0) {
            let it = i.Items[0];
            if (it.jimun_multi === "[]" && it.mail_attachment == undefined) {
              return false
            } else {
              return true
            }
          } else {
            return false;
          }
        }, rows);

        let index = 1;
        rows = R.map(x => {
          x.index = index;
          index++;
          return x
        }, rows);

        console.log(rows);
        context.state.paper_slides = rows;
      });
    },

    loadQnaMeta(context, paper_id) {
      let url = `${Constant.FullGetApi}/${paper_id}`;
      axios.get(url).then(resp => {
        let data = resp.data
        context.state.qnaMeta = data;

      });

    },
    loadQnaList(context, paper_id) {
      let page = context.state.qna_pos;
      let order = context.state.qna_order;
      let limit = 10;

      let url = `${Constant.QnaListGetApi}?paper_id=${paper_id}&page=${page}&order=${order}&limit=${limit}`;
      axios.get(url).then(resp => {
        let rows = resp.data.qnas;
        context.state.qna_list = rows;
        context.state.qna_totalpage = resp.data.totalpage;
        context.state.qna_more_count = 1;
      });
    },

    loadNonFullList(context, non_type) {
      let clsid = localStorage.getItem("clsid");
      let subflag = null;
      if (non_type === 'quiz') {
        subflag = 'non_live';
      } else if (non_type === 'poll') {
        subflag = 'survey';
      }
      let url = `${Constant.FullGetApi}?classroom_id=${clsid}&flag=${non_type}&subflag=${subflag}`;
      axios.get(url).then(resp => {
        let rows = resp.data.rows;
        context.state.paper_quiz = rows;
      });

    },
    loadNonItemList(context, paper_id) { // 비실시간성 퀴즈,설문 로드용 
      let url = `${Constant.NonItemlist}/${paper_id}`;
      axios.get(url).then(resp => {

        context.state.non_items = resp.data;
        // context.commit("updateQnaView", resp.data)
      })

    },

    loadQnaView(context, qna_id) {
      // let url = `${Constant.QnaListGetApi}/${qna_id}`;
      let nick = localStorage.getItem("default_info");
      let url = `${Constant.QnaListGetApi}/${qna_id}?writer=${nick}`;

      axios.get(url).then(resp => {
        // context.state.qna_view = resp.data;
        context.commit("updateQnaView", resp.data)
      })
    },
    blankQnaview(context) {

      context.state.qna_view = {
        Qnalikes: [],
        Qnacomments: [],
        id: null,
        writer: null,
        secret: 0,
        text: null,
        paper_id: null,
      };
    },
    loadQnaMore(context, paper_id) {

      if (context.state.qna_totalpage > context.state.qna_pos) {
        context.state.qna_pos = context.state.qna_pos + 1;

        let page = context.state.qna_pos;
        let order = context.state.qna_order;
        let limit = 12;
        let url = `${Constant.QnaListGetApi}?paper_id=${paper_id}&page=${page}&order=${order}&limit=${limit}`;
        axios.get(url).then(resp => {
          let rows = resp.data.qnas;
          context.state.qna_list.push(...rows);
          context.state.qna_more_count += 1;

        });

      }



    },
    toggleQnaOrder(context) {
      if (context.state.qna_order === "favor") {
        context.state.qna_order = "recently"
      } else {
        context.state.qna_order = "favor"
      }

    },
    setClassInfo(context, clsid) {
      context.commit('setClsid', clsid);
      //restapi를 통한 api  처리
      // let url = "";

      let url = `${Constant.ClassroomGetApi}/${clsid}`;
      axios.get(url).then(resp => {
        let data = resp.data;

        if (data === '') {

          console.log("data(clsid) is not found")
          window.document.location.href = "http://next.weliveon.net";
        } else {
          let att_info = JSON.parse(data.att_info);

          context.state.clsMeta = data;
          context.state.att_info = att_info;
          if (data.banner != null) {
            context.state.bannersrc = JSON.parse(data.banner).url;
            localStorage.setItem("bannersrc", JSON.parse(data.banner).url);
          } else {
            localStorage.removeItem("bannersrc");
          }

        }
      });
      let url2 = `${Constant.PaperApi}?classroom_id=${clsid}`;
      axios.get(url2).then(resp => {
        let data = resp.data;
        if (data.count > 0) {
          let first = data.rows[0];
          if (first.flag === 'timetable') {
            context.state.hasTimeTable = true;
          } else {
            context.state.hasTimeTable = false;
          }
        } else {
          context.state.hasTimeTable = false;
        }
      });


    },
    saveUserToPersist(context, payload) {
      //todo: localstorage 


      let url_check_unique_nick = `${Constant.ClassroomUserPostApi}?classroom_id=${payload.classroom_id}&default_info=${payload.default_info}`

      axios.get(url_check_unique_nick).then(resp => {
        let data = resp.data;
        if (data.count > 0) {
          alert("동일아이디가 사용중입니다");
        } else {
          let clsid = context.state.clsid;
          localStorage.setItem("clsid", clsid);
          localStorage.setItem(`default_info_${clsid}`, payload.default_info);
          localStorage.setItem(`default_info`, payload.default_info);

          sessionStorage.setItem("clsid", clsid);

          let uuid = null;
          if (sessionStorage.getItem("uuid") != null) {
            uuid = sessionStorage.getItem("uuid")
          } else {
            uuid = getUUID();
          }


          let socket_payload = {

            "wayto": "REGISTER_NICK",
            "payload": {
              "classroom_id": context.state.clsid,
              "nick": payload.default_info,
              "uuid": uuid
            }
          }
          context.commit(
            'UPDATE_WSDATA', socket_payload
          )

          let url = `${Constant.ClassroomUserPostApi}`
          axios.post(url, payload).then(() => {

          })

          router.replace("/main");
        }

      })



    },
    logoutSocket(context) {

      socket.onclose = function () { }; // disable onclose handler first
      socket.close();
      location.reload();
    }
  },
  getters: {
    getDefaultInfo: state => {
      return localStorage.getItem("default_info");
    },
    getClassroomId: state => {
      return localStorage.getItem("clsid")
    },
    getAttInfo: state => {
      return state.att_info;
    },
    getClsMeta: state => {
      return state.clsMeta;
    },
    getItemMeta: state => {
      return state.itemMeta;
    },

    getShowGnb: state => {
      return state.showGnb;
    },
    getQnaList: state => {
      return state.paper_qna;
    },
    getQnaSubjectTitle: state => {
      return state.qnaMeta.title;
    },
    getQnaSubjectIndex: state => {
      return state.qna_logical_index;
    },
    getQnaItems: state => {
      return state.qna_list;
    },
    getQnaOrder: state => {
      return state.qna_order;
    },
    getQnaView: state => {
      return state.qna_view;
    },
    getQnaViewText: state => {
      return state.qna_view.text
    }


  },


})

export default MyStore;
